import { render, staticRenderFns } from "./selectSentenceByVoice.vue?vue&type=template&id=070dcb4a&scoped=true"
import script from "./selectSentenceByVoice.vue?vue&type=script&lang=js"
export * from "./selectSentenceByVoice.vue?vue&type=script&lang=js"
import style0 from "./selectSentenceByVoice.vue?vue&type=style&index=0&id=070dcb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070dcb4a",
  null
  
)

export default component.exports